(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-w-img"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-faq-toggle]');
    if (!toggle) return;

    const item = toggle.closest('.faq-split__item');
    const isOpen = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-page-nav"] && !Shopify.designMode) return;
  try {
    
  class OnPageNav extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-bar]');
      this.spacer = this.querySelector('[data-spacer]');
      this.sentinel = this.querySelector('[data-sentinel]');
      this.links = Array.from(this.querySelectorAll('[data-nav-link]'));
      this.mobileToggle = this.querySelector('[data-mobile-toggle]');
      this.mobileLabel = this.querySelector('[data-mobile-toggle-label]');
      this.listWrapper = this.querySelector('[data-list-wrapper]');
      if (!this.links.length) return;

      this.targets = this.links
        .map((link) => document.getElementById(link.dataset.target))
        .filter(Boolean);

      this.links.forEach((link) => {
        link.addEventListener('click', (event) => this.handleClick(event, link));
      });

      this.setupMobileToggle();
      this.setupBarHeightSync();
      this.setupPinning();
      this.setupObserver();
      this.setupOutsideClick();
    }

    setupMobileToggle() {
      if (!this.mobileToggle || !this.listWrapper) return;

      this.mobileToggle.addEventListener('click', () => {
        const isOpen = this.classList.toggle('is-nav-open');
        this.mobileToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    closeMobileNav() {
      if (!this.classList.contains('is-nav-open')) return;
      this.classList.remove('is-nav-open');
      if (this.mobileToggle) this.mobileToggle.setAttribute('aria-expanded', 'false');
    }

    setupOutsideClick() {
      document.addEventListener('click', (event) => {
        if (!this.classList.contains('is-nav-open')) return;
        if (this.contains(event.target)) return;
        this.closeMobileNav();
      });
    }

    // Keeps --opn-bar-height in sync with the bar's real rendered height at
    // all times — including while the mobile dropdown opens/closes — so the
    // spacer is always already the correct size *before* the bar switches
    // between static and fixed. Doing this ahead of time (instead of
    // measuring inside pin()) is what removes the jump/"blink" on the
    // sticky transition: pin()/unpin() then only ever toggle a class, with
    // no layout read in between, so the browser applies both changes in a
    // single paint instead of two.
    setupBarHeightSync() {
      const updateHeight = () => {
        this.style.setProperty('--opn-bar-height', `${this.bar.offsetHeight}px`);
      };

      updateHeight();

      if ('ResizeObserver' in window) {
        this.barResizeObserver = new ResizeObserver(updateHeight);
        this.barResizeObserver.observe(this.bar);
      } else {
        window.addEventListener('resize', updateHeight);
      }
    }

    setupPinning() {
      if (!this.bar || !this.sentinel || !('IntersectionObserver' in window)) return;

      const pin = () => this.classList.add('is-pinned');
      const unpin = () => {
        this.classList.remove('is-pinned');
        this.closeMobileNav();
      };

      // When the 1px sentinel (placed right above the bar) scrolls out of
      // the top of the viewport, switch the bar to fixed. When it scrolls
      // back into view, un-fix it — matching native sticky behavior but
      // without depending on any ancestor's overflow/transform.
      this.pinObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              unpin();
            } else if (entry.boundingClientRect.top < 0) {
              pin();
            }
          });
        },
        { root: null, threshold: 0 }
      );

      this.pinObserver.observe(this.sentinel);
    }

    getStickyHeight() {
      // Own height plus a little breathing room, so target sections aren't
      // hidden underneath the pinned bar after scrolling.
      return this.bar.offsetHeight + 12;
    }

    handleClick(event, link) {
      const target = document.getElementById(link.dataset.target);
      if (!target) return;

      event.preventDefault();
      this.closeMobileNav();

      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const offset = this.getStickyHeight();

      window.scrollTo({
        top: targetTop - offset,
        behavior: 'smooth',
      });

      history.pushState(null, '', `#${link.dataset.target}`);
    }

    setupObserver() {
      if (!('IntersectionObserver' in window) || !this.targets.length) return;

      const setActive = (id) => {
        this.links.forEach((link) => {
          const isActive = link.dataset.target === id;
          link.classList.toggle('is-active', isActive);
          if (isActive && this.mobileLabel) {
            this.mobileLabel.textContent = link.textContent.trim();
          }
        });
      };

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActive(entry.target.id);
            }
          });
        },
        {
          root: null,
          rootMargin: `-${this.getStickyHeight() + 20}px 0px -60% 0px`,
          threshold: 0,
        }
      );

      this.targets.forEach((target) => this.observer.observe(target));
    }
  }

  if (!customElements.get('on-page-nav')) {
    customElements.define('on-page-nav', OnPageNav);
  }

  } catch(e) { console.error(e); }
})();
})();
